import { render, staticRenderFns } from "./DeviceGenericObject.vue?vue&type=template&id=4c326b9a&scoped=true&"
import script from "./DeviceGenericObject.vue?vue&type=script&lang=js&"
export * from "./DeviceGenericObject.vue?vue&type=script&lang=js&"
import style0 from "./DeviceGenericObject.vue?vue&type=style&index=0&id=4c326b9a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c326b9a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c326b9a')) {
      api.createRecord('4c326b9a', component.options)
    } else {
      api.reload('4c326b9a', component.options)
    }
    module.hot.accept("./DeviceGenericObject.vue?vue&type=template&id=4c326b9a&scoped=true&", function () {
      api.rerender('4c326b9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/device/device_types/DeviceGenericObject.vue"
export default component.exports